import React, { Fragment } from 'react';
import { useHomeSections } from './use-home-sections';
import { useSearchParams } from '../../../../play-core/hooks/use-search-params';
import { VerticalScrollTracker } from '../../analytics/VerticalScrollTracker';
import { ErrorIfEmpty } from '../../components/Message/ErrorIfEmpty';
import { usePageTitle } from '../../components/Meta/PlayMetaData';
import { Sections } from '../../components/Section/Sections';
import { useVideoConfig } from '../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HomePage = ({
  initialData
}) => {
  const {
    pageId
  } = useSearchParams();
  const {
    usePreview
  } = useVideoConfig();
  const {
    homeSections,
    isLoading
  } = useHomeSections(initialData, pageId);
  usePageTitle();
  const content = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(VerticalScrollTracker, {
      pageTitle: "Home"
    }), /*#__PURE__*/_jsx(Sections, {
      initialData: initialData,
      sections: homeSections
    })]
  });
  return usePreview ? content : /*#__PURE__*/_jsx(ErrorIfEmpty, {
    isLoading: isLoading,
    children: content
  });
};